import { useState, useEffect } from "react"

const ScreenStatusModel = {
  xs: false,
  sm: false,
  md: false,
  lg: false,
  xl: false,
}

export const useBreakpoint = () => {
  const [screenSize, setScreenSize] = useState(ScreenStatusModel)

  useEffect(() => {
    const updateScreenSize = () => {
      const width = window.innerWidth
      setScreenSize({
        xs: width < 576,
        sm: width >= 576 && width < 768,
        md: width >= 768 && width < 992,
        lg: width >= 992 && width < 1200,
        xl: width >= 1200,
      })
    }
    window.addEventListener("resize", updateScreenSize)
    updateScreenSize()
    return () => window.removeEventListener("resize", updateScreenSize)
  }, [])


  return screenSize
}
